import React from 'react';
import Flag from 'react-country-flag';

import Fide from 'assets/countries/fide.png';

const FlagWrapper = ({countryCode, size = '100%', style}) => {
    if (countryCode === 'fide' || countryCode === 'FIDE' || countryCode === 'un') {
        const imgStyle = style ? style : {height: size};
        // eslint-disable-next-line jsx-a11y/alt-text
        return <img src={Fide} style={imgStyle} />;
    }
    const imgStyle = style ? style : {};
    return <Flag countryCode={countryCode} svg style={imgStyle} />;
};

export default FlagWrapper;
